import { Skeleton } from "antd";

import { getLogoHeight, getSkeletonWidth, useLogoStyles } from "./logo-style";

import type { CompanyLogoProps } from "./types";

type ImageLogoProps = CompanyLogoProps & {
  onError?: () => void;
};

export function ImageLogo({ size = "default", company, onError, testIdPrefix }: ImageLogoProps) {
  const { styles } = useLogoStyles({ size });
  const logoTestId = `${testIdPrefix}-image-logo`;
  const logoContentTestId = `${logoTestId}-content`;

  return (
    <div className={styles.logoContainer} data-testid={logoTestId}>
      {company ? (
        <div className={styles.logoBox}>
          {/* TODO: Use Image atom once we figure out styling */}
          <img
            src={company.logoUrl}
            alt={`${company.commonName} logo`}
            className={styles.imageLogo}
            data-testid={logoContentTestId}
            onError={onError}
          />
        </div>
      ) : (
        <div data-testid={logoContentTestId}>
          <Skeleton.Input
            active
            size="small"
            style={{
              width: getSkeletonWidth(size),
              height: getLogoHeight(size),
            }}
          />
        </div>
      )}
    </div>
  );
}
